import SkapaListView, {
  type ListViewItemProps,
  type ListViewProps,
  ListViewItem as SkapaListViewItem,
} from "@ingka/list-view";

const ListView = (
  props: ListViewProps & React.RefAttributes<HTMLUListElement>
) => {
  return <SkapaListView prefix="saleslead__" {...props} />;
};

const ListViewItem = (
  props: ListViewItemProps & React.RefAttributes<HTMLLIElement>
) => {
  return (
    <SkapaListViewItem
      prefix="saleslead__"
      emphasised={props.emphasised ?? true}
      controlIcon={props.controlIcon ?? "chevronRightSmall"}
      {...props}
    />
  );
};

export { ListView, ListViewItem, type ListViewItemProps };
